<div class="centros-dialog">

  <div class="dialog-header">
    <div class="dialog-header-info">
      <h3 class="dialog-title">{{ data.nombre }}</h3>
      <p class="dialog-subtitle" *ngIf="data.zona?.concepto || data.localidad?.nombre">
        <mat-icon class="dialog-icon">location_on</mat-icon>
        {{ data.zona?.concepto }} - {{ data.localidad?.nombre }}
      </p>
    </div>
    <button mat-icon-button (click)="closeDialog(null)" class="dialog-close" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-contact" *ngIf="data.telefonos || data.celular">
    <div class="contact-item" *ngIf="data.telefonos">
      <mat-icon class="contact-icon">call</mat-icon>
      <span>{{ data.telefonos }}</span>
    </div>
    <div class="contact-item" *ngIf="data.celular">
      <mat-icon class="contact-icon contact-icon--whatsapp">chat</mat-icon>
      <a href="https://api.whatsapp.com/send?phone={{ data.celular }}" target="_blank" class="whatsapp-link">
        {{ data.celular }}
      </a>
    </div>
  </div>

  <div class="dialog-map" *ngIf="data.latitud !== 0 || data.longitud !== 0; else noMap">
    <app-map></app-map>
  </div>

  <ng-template #noMap>
    <div class="dialog-no-map">
      <mat-icon class="no-map-icon">location_off</mat-icon>
      <p>Este centro no cuenta con mapa de ubicación actualmente.</p>
    </div>
  </ng-template>

</div>
